import { DeliveryParcel, FlightInternational, Location, Time } from "@carbon/icons-react"
import tsawImg from "../assets/TSAW-logo-edit.png"
import { getFlightReportsData } from "../api/authAPI";
import { useQuery } from "@tanstack/react-query";
import { useEffect, useState } from "react";


const FlightRecordComponent = () => {

    const [flightsData, setFlightsData] = useState({})
    const flightsDataQuery = useQuery(["flightsData"], getFlightReportsData, {
        refetchInterval: 600000, // 10 minutes
    });

    useEffect(() => {
        setFlightsData(flightsDataQuery?.data?.data?.data);
    }, [flightsDataQuery?.data]);

    return (
        <>
            <div className="h-full w-full bg-tblu max-w-[100vw] mx-auto">
                <div className={`grid grid-cols-11 `}>
                    <div className="flex flex-col justify-around items-end col-span-5">
                        <div className="h-[15vw] w-[35vw] bg-white shadow-lg  rounded-3xl p-4 flex flex-col items-center justify-center space-y-5">
                            <Time size={50} />
                            <h1 className="font-extrabold text-[1.5vw]">Flight Hours</h1>
                            <h1 className="font-semibold text-[3vw]">{flightsData?.hoursFlight}</h1>
                        </div>

                        <div className="h-[15vw] w-[35vw] bg-white shadow-lg  rounded-3xl p-4 flex flex-col items-center justify-center space-y-5">
                            <Location size={50} />
                            <h1 className="font-extrabold text-[1.5vw]">Distance Covered (in Km)</h1>
                            <h1 className="font-semibold text-[3vw]">{flightsData?.distanceCovered}</h1>
                        </div>
                    </div>

                    <div className="grid h-screen place-items-center">
                        <div className=" rounded-full h-[20vh] justify-center w-[20vh] bg-white shadow-lg flex items-end">
                            <img className="h-5/6 pt-2 w-5/6" src={tsawImg} alt="" />
                        </div>
                    </div>
                    <div className="flex flex-col justify-around col-span-5">
                        <div className="h-[15vw] w-[35vw] bg-white shadow-lg  rounded-3xl p-4 flex flex-col items-center justify-center space-y-5">
                            <DeliveryParcel size={50} />
                            <h1 className="font-extrabold text-[1.5vw]">Delivery Completed</h1>
                            <h1 className="font-semibold text-[3vw]">{flightsData?.deliveryCompleted}</h1>
                        </div>
                        <div className="h-[15vw] w-[35vw] bg-white shadow-lg  rounded-3xl p-4 flex flex-col items-center justify-center space-y-5">
                            <FlightInternational size={50} />
                            <h1 className="font-extrabold text-[1.5vw]">Total Flights</h1>
                            <h1 className="font-semibold text-[3vw]">{flightsData?.totalFlight}</h1>
                        </div>
                    </div>
                </div>
            </div>
        </>
    )
}

export default FlightRecordComponent